/**
 * Build a Google Maps URL for a location.
 * Prefers coordinates when both lat and lng are present; otherwise uses address.
 * Opens in browser (new tab) and on mobile can open in Google Maps app.
 */
export function getGoogleMapsUrl(params: {
  latitude?: number | null;
  longitude?: number | null;
  address?: string | null;
}): string | null {
  const { latitude, longitude, address } = params;
  const hasCoords =
    typeof latitude === "number" &&
    typeof longitude === "number" &&
    !Number.isNaN(latitude) &&
    !Number.isNaN(longitude);
  if (hasCoords) {
    return `https://www.google.com/maps?q=${latitude},${longitude}`;
  }
  if (address && address.trim()) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.trim())}`;
  }
  return null;
}

/**
 * Build Google Maps embed URL for a small iframe map (no API key).
 * Use same preference: coordinates first, then address.
 */
export function getGoogleMapsEmbedUrl(params: {
  latitude?: number | null;
  longitude?: number | null;
  address?: string | null;
}): string | null {
  const { latitude, longitude, address } = params;
  const hasCoords =
    typeof latitude === "number" &&
    typeof longitude === "number" &&
    !Number.isNaN(latitude) &&
    !Number.isNaN(longitude);
  if (hasCoords) {
    return `https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`;
  }
  if (address && address.trim()) {
    return `https://www.google.com/maps?q=${encodeURIComponent(address.trim())}&output=embed`;
  }
  return null;
}
